import getUserConfigurationForMailbox from './getUserConfigurationForMailbox';
import { isConnectedAccount } from './isConnectedAccount';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/***
 * Function that checks whether the email address represents a consumer account
 * Note: Use this method, instead of isConsumer in owa-session-store, for features supporting connected accounts.
 * @param {string} emailAddress The email address of the account
 */
export function isConsumer(emailAddress: string): boolean {
    const userConfig = isConnectedAccount(emailAddress)
        ? getUserConfigurationForMailbox(emailAddress)
        : getUserConfiguration();
    return userConfig && userConfig.SessionSettings.WebSessionType !== WebSessionType.Business;
}
